var map = {
	"./img_1.jpg": 25885,
	"./img_2.jpg": 26226,
	"./img_3.jpg": 55048,
	"./img_4.jpg": 9460,
	"./img_5.jpg": 23539,
	"./img_6.jpg": 76693,
	"./img_7.jpg": 17005
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45022;